module.exports = __webpack_public_path__ + "img/4.02.thmb.8b28e20a.jpg";